// 上游收款信息
<template>
  <div>
    <div class="content" v-loading.fullscreen.lock="fullscreenLoading" v-show="!showDialogBox">
      <!-- search start -->
      <div class="search-area">
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="search-area-div">付款方&nbsp;&nbsp;&nbsp;</div>
            <el-select size="mini" class="ipt-sty" v-model="page.payTenantGuid" placeholder="请选择" filterable>
              <el-option v-for="item in receiveTenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">收款方&nbsp;&nbsp;&nbsp;</div>
            <el-select size="mini" class="ipt-sty" v-model="page.receiveTenantGuid" placeholder="请选择" filterable>
              <el-option v-for="item in invoiceTenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">支付方&nbsp;&nbsp;&nbsp;</div>
            <el-select
              size="mini"
              class="ipt-sty"
              v-model="page.prePaymentPayTenantGuid"
              placeholder="请选择"
              filterable
            >
              <el-option v-for="item in serviceTenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
              </el-option>
            </el-select>
          </el-col>

          <el-col :span="6" class="search-btn-box">
            <el-button
              size="mini"
              type="text"
              @click="showMore = !showMore"
              :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            >
              {{ showMore ? '收起筛选' : '更多筛选' }}
            </el-button>
            <el-button size="mini" type="info" @click="search">搜索</el-button>
            <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="mt15" v-show="showMore">
          <el-col :span="6">
            <div class="search-area-div">收款日期</div>
            <el-date-picker
              size="mini"
              v-model="invoiceDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              class="ipt-sty"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">对应款项</div>
            <el-select size="mini" class="ipt-sty" v-model="page.correspondItem" placeholder="请选择" filterable>
              <el-option
                v-for="item in getCodeListByKey('对应款项')"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">预支付日期</div>
            <el-date-picker
              size="mini"
              v-model="prePaymentDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              class="ipt-sty"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-col>
        </el-row>
      </div>
      <!-- search end -->

      <!-- table start -->
      <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'">
        <div class="button-area">
          <div>
            <el-button
              icon="el-icon-plus"
              v-if="getBtnPermissionsByName('新增收款信息')"
              size="mini"
              type="info"
              @click="addCollectionInfo"
              >新增收款信息</el-button
            >
            <el-button
              size="mini"
              v-if="getBtnPermissionsByName('批量导入')"
              type="info"
              @click="batchImport()"
              v-loading.fullscreen.lock="fullscreenLoading"
              >批量导入</el-button
            >
            <el-button
              size="mini"
              v-if="getBtnPermissionsByName('导出')"
              type="info"
              @click="batchExport()"
              v-loading.fullscreen.lock="fullscreenLoading"
              >导出</el-button
            >
          </div>
          <div v-if="totalLoading">
            <span style="color: #FF5F1F;">正在合计中...</span>
          </div>
          <div v-else>
            合计收款金额：<span>{{ amountSumOne |numDigit }}</span>&nbsp;元
          </div>
        </div>
        <el-table
          :height="tableHeight"
          :data="tableData"
          stripe
          border
          style="width: 100%"
          ref="tableRef"
          v-loading="tableLoading"
        >
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="payTenantName"
            label="付款方"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="210"
          >
            <template slot-scope="scope">
              <div @click="toogleExpand(scope.row)">{{ scope.row.payTenantName || '-' }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="templateName"
            label="收款方"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="210"
          >
            <template slot-scope="scope">
              <div @click="toogleExpand(scope.row)">{{ scope.row.receiveTenantName || '-' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" sortable width="120" label="收款日期" header-align="center" align="left">
            <template slot-scope="scope">
              <div @click="toogleExpand(scope.row)">{{ scope.row.receiveDate | getDate }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="taskTotal"
            width="100"
            label="对应款项"
            show-overflow-tooltip
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">
              <div @click="toogleExpand(scope.row)">
                {{ getName(scope.row.correspondItem, '对应款项') }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="receiveAmount"
            width="120"
            label="收款金额(元)"
            show-overflow-tooltip
            header-align="center"
            align="right"
          >
            <template slot-scope="scope">
              <div @click="toogleExpand(scope.row)">{{ scope.row.receiveAmount | numDigit }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="预计支付笔数(笔)" width="120" header-align="center" align="left">
            <template slot-scope="scope">
              <div @click="toogleExpand(scope.row)">
                {{ scope.row.prePaymentList ? scope.row.prePaymentList.length : '0' }}
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="createTime" label="操作人" width="100" header-align="center" align="left">
            <template slot-scope="scope">
              <div @click="toogleExpand(scope.row)">{{ scope.row.updateUserName || '-' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" sortable label="录入时间" width="140" header-align="center" align="left">
            <template slot-scope="scope">
              <div @click="toogleExpand(scope.row)">{{ scope.row.createTime | getTime }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" sortable label="操作时间" width="140" header-align="center" align="left">
            <template slot-scope="scope">
              <div @click="toogleExpand(scope.row)">{{ scope.row.updateTime | getTime }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="数据来源" min-width="96" header-align="center" align="left">
            <template slot-scope="scope">
              <div @click="toogleExpand(scope.row)">{{ scope.row.sourceType | sourceTypeFilter }}</div>
            </template>
          </el-table-column>
          <!-- 嵌套表start -->
          <el-table-column type="expand" width="1">
            <template slot-scope="prop">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-table :data="prop.row.prePaymentList" stripe border max-height="250">
                  <el-table-column type="index" width="60" header-align="center" align="center">
                    <template slot-scope="scopeChild">
                      {{ (page.pageIndex - 1) * page.pageSize + scopeChild.$index + 1 }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="prePaymentDate"
                    label="预支付日期"
                    width="210"
                    header-align="center"
                    align="left"
                  >
                    <template slot-scope="scopeChild">{{ scopeChild.row.prePaymentDate | getDate }}</template>
                  </el-table-column>
                  <el-table-column
                    prop="levyTenantName"
                    label="下游支付方"
                    width="210"
                    header-align="center"
                    align="left"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="payAmount"
                    width="160"
                    label="预支付金额(元)"
                    show-overflow-tooltip
                    header-align="center"
                    align="right"
                  >
                    <template slot-scope="scopeChild">
                      {{ scopeChild.row.payAmount | numDigit }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="createTime" label="操作人" width="120" header-align="center" align="left">
                    <template slot-scope="scopeChild">{{ scopeChild.row.updateUserName || '-' }}</template>
                  </el-table-column>
                  <el-table-column prop="createTime" label="录入时间" width="500" header-align="left" align="left">
                    <template slot-scope="scopeChild">{{ scopeChild.row.updateTime | getTime }}</template>
                  </el-table-column>
                </el-table>
              </el-form>
            </template>
          </el-table-column>
          <!-- 嵌套表end -->
          <el-table-column prop="bank" min-width="220" label="操作" header-align="center" align="center" fixed="right">
            <template slot-scope="scope">
              <div v-if="currentMenu">
                <a
                  :class="[dataPermissions(scope.row) ? 'txt-color' : 'disable-color']"
                  v-if="getBtnPermissionsByName('预支付管理')"
                  @click="addPaymentPlan(scope.row, $event, scope.$index)"
                  >预支付管理&nbsp;&nbsp;
                </a>
                <a
                  class="txt-color"
                  v-if="scope.row.createUserId === userinfo.userGuid || getBtnPermissionsByName('编辑')"
                  scope.row
                  @click="editForm(scope.row.guid,scope.$index)"
                  >编辑&nbsp;&nbsp;
                </a>
                <a class="txt-color" v-if="getBtnPermissionsByName('详情')" @click="lookForm(scope.row.guid,scope.$index)"
                  >详情&nbsp;&nbsp;</a
                >
                <a
                  class="txt-color"
                  style="color: red !important"
                  v-if="scope.row.createUserId === userinfo.userGuid && getBtnPermissionsByName('删除')"
                  @click="delForm(scope.row.guid)"
                  >删除</a
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        class="pt pb back-color-fff content-pagination-box"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100, 200]"
        :current-page="page.pageIndex"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalRows"
      >
      </el-pagination>
      <!-- table end -->
    </div>
    <AddCollectionDialogBox
      ref="AddCollectionDialogBox"
      :paramCollection="paramCollection"
      :invoiceTenantList="invoiceTenantList"
      :receiveTenantList="receiveTenantList"
      @closedDialogBox="closedDialogBox"
    ></AddCollectionDialogBox>
  </div>
</template>

<script>
import AddCollectionDialogBox from './components/addCollectionDialogBox';
import { route } from '@/api/apiRoute';
import store from '@/store';
import btnPermisson from '../mixins/btnPermisson';
export default {
  mixins:[btnPermisson],
  components: {
    AddCollectionDialogBox,
  },
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      currentExpand: {},
      currentPath: '',
      currentMenu: null,
      AllPaymentList: [],
      btnPermissions: [],
      serviceTenantList: [], // 支付方-代征公司
      userinfo,
      userGuid: userinfo.userGuid || [],
      showMore: false,
      tableHeight: window.innerHeight - 263,
      contentMainHeight: window.innerHeight - 200,
      fullscreenLoading: false,
      totalLoading:true,
      tableData: [],
      invoiceDate: [], // 开票日期
      prePaymentDate: [], // 预支付日期
      page: {
        streamType: '1', // 上游
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        payTenantGuid: '', //付款方
        prePaymentPayTenantGuid: '', //收款方
        receiveTenantGuid: '', //支付方 (预支付)
        correspondItem: '', //对应款项
        receiveDateStart: '',
        receiveDateEnd: '',
        serviceTenantGuid: localStorage.guid,
      },
      paramCollection: {
        // 新增收款信息传递参数
        streamType: '1', //  1上游 2下游
        index: '', // 款项信息的索引
        title: '',
        operationType: '',
        invoiceTenantGuid: '', // 收票方（支付方）唯一标识
        invoiceTenantName: '', // 收票方（支付方）name
        receiveTenantGuid: '', // 开票方（收款方）唯一标识
        receiveTenantName: '', // 开票方（收款方）name
        correspondItem: '', //对应款项
      },
      invoiceTenantList: [],
      receiveTenantList: [],
      showDialogBox: false, // 显示收款信息表单
      amountSumOne:'',//合计收款金额
    };
  },
  beforeRouteEnter(to, from, next) {
    if (from.path === '/addUpstreamPaymentPlan') {
      next((vm) => {
        vm.getList(() => {
          let currentExpand = vm.$store.getters.getCurrentExpand || {};
          // vm.toogleExpand(currentExpand, 'goBack'); // 返回展开逻辑
          if (vm.$store.getters.getPageY) vm.tableScrollToRow(vm.$refs.tableRef, vm.$store.getters.getPageY); // 表格行跳转
        });
      });
    } else {
      next();
    }
  },
  created() {
    this.getMenuList(); // 获取按钮配置
    this.getList();
    this.getInvoiceTenantList(); // 付款方(药企)
    this.getReceiveTenantList(); // 收款方(服务商)
    this.getServiceTenantList(); // 支付方(代征公司)
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 310;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 263;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  methods: {
    getSumAmount(list,attr) {
      let sum = 0;
      list.forEach(item => {
        // sum += item.settleAmount;
        sum += Math.round(item[attr] * 100) / 100 ;
      })
      return sum
    },
    // 获取菜单列表
    getMenuList() {
      this.tableLoading = true;
      let productGuid = this.$route.query.productGuid || localStorage.productGuid;
      let reqUrl = `/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get-menu-by-currentuser?appType=01&tenantGuid=${localStorage.guid}&productGuid=${productGuid}&appSideIdentifier=scm_operative`;
      this.api.get(reqUrl).then((res) => {
        this.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let menuList = res.data.data;
          this.currentPath = this.$route.path;
          this.currentMenu = this.getNodeByPath(this.currentPath, menuList);
          this.getBtnPermissions(this.currentMenu);
          console.log(this.currentMenu, 'currentMenu');
        }
      });
    },
    // todo 创建这个预支付的人才能操作
    dataPermissions(item) {
      let { prePaymentList } = item;
      return Array.isArray(prePaymentList) && prePaymentList.length
        ? prePaymentList.find((item) => item.createUserId === this.userGuid)
        : true;
    },
    // 获取按钮list
    getBtnPermissions(currentMenu) {
      if (currentMenu && Array.isArray(currentMenu.children)) {
        this.btnPermissions = currentMenu.children.filter((item) => item.menuType === 'F');
      }
    },
    // 按钮权限匹配
    getBtnPermissionsByName(menuName) {
      return (
        (!this.btnPermissions.length || this.btnPermissions.find((item) => item.menuName === menuName)) &&
        this.currentMenu
      );
    },
    getNodeByPath(path, tree) {
      //设置结果
      let result;
      if (!tree) {
        return;
      }
      for (let i = 0; i < tree.length; i++) {
        let item = tree[i];
        if (item.path == path) {
          result = item;
          return result;
        } else if (item.children && item.children.length > 0) {
          result = this.getNodeByPath(path, item.children);
          if (result) {
            return result;
          }
        }
      }
      //如果执行循环中都没有return，则在此return
      return result;
    },
    getAllPaymentList() {
      this.api.postJson(`/${serverConfig.msCustomerService}/pre-payment-info/list`, {}).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.AllPaymentList = res.data.data;
        } else {
          this.AllPaymentList = [];
        }
      });
    },
    // 批量导入
    batchImport() {
      this.$router.push({ path: '/importFinancialInfor',query:{ productGuid:this.$route.query.productGuid} });
    },
    //批量导出
    batchExport() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        streamType: '2',
        payTenantGuid: this.page.payTenantGuid, // #开票方
        receiveTenantGuid: this.page.receiveTenantGuid, // #收票方
        correspondItem: this.page.correspondItem,
        receiveDateEnd: this.page.receiveDateEnd,
        receiveDateStart: this.page.receiveDateStart,
        serviceTenantGuid: localStorage.guid,
      };
      self.fullscreenLoading = true;
      self.api.postJsonD(`/${serverConfig.msCustomerService}/invoiceItem/export-upstream`, req).then((res) => {
        let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        let fileName = '上游收款信息' + this.$moment(new Date()).format('YYYYMMDD');
        let objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.download = fileName;
        link.href = objectUrl;
        link.click();
        self.fullscreenLoading = false;
      });
    },
    //获取开票方（收款方）
    getInvoiceTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['9901'],
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.invoiceTenantList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取收票方（支付方）
    getReceiveTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.receiveTenantList = [];
            res.data.data.forEach((item) => {
              self.receiveTenantList.push({
                guid: item.sendTenantGuid,
                tenantName: item.sendTenantName,
              });
            });
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getName(name, key) {
      let list = this.getCodeListByKey(key);
      let lisArr = list.filter((item) => item.value == name);
      return lisArr.length ? lisArr[0].text : '-';
    },
    search() {
      let self = this;
      self.page.serviceTenantGuid = localStorage.guid;
      self.page.receiveDateStart = self.invoiceDate ? self.invoiceDate[0] : '';
      self.page.receiveDateEnd = self.invoiceDate ? self.invoiceDate[1] : '';
      self.page.prePaymentDateStart = self.prePaymentDate ? self.prePaymentDate[0] : '';
      self.page.prePaymentDateEnd = self.prePaymentDate ? self.prePaymentDate[1] : '';
      this.getAmount()
      self.page.pageIndex = 1;
      self.tableLoading = true;
      self.tableData = []
      self.api.postJson(`/${serverConfig.msCustomerService}/invoiceItem/page-list`, self.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records||[];
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getAmount() {
      let self = this;
      let req=JSON.parse(JSON.stringify(this.page))
      req.pageSize=-1
      req.pageIndex = 1;
      self.totalLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/invoiceItem/amount-sum`, req).then((res) => {
        self.totalLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.amountSumOne = res.data.data;
          self.$forceUpdate()
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.invoiceDate = [];
      this.prePaymentDate = [];
      this.page = {
        streamType: '1', // 上游
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        invoiceTenantGuid: '', //开票方
        receiveTenantGuid: '', //收票方
        correspondItem: '', //对应款项
        receiveDateStart: '',
        receiveDateEnd: '',
        prePaymentDateStart: '',
        prePaymentDateEnd: '',
        payTenantGuid: '',
        prePaymentPayTenantGuid: '',
        serviceTenantGuid: localStorage.guid,
      };
      this.getList();
    },
    addVersion() {
      this.$router.push('/upstreamInvoiceEdit?productGuid=' + this.$route.query.productGuid);
    },
    editForm(guid, index) {
      this.$store.commit('setPageY', index);
      this.editCollectionInfo(guid, 'edit');
    },
    lookForm(guid, index) {
      this.$store.commit('setPageY', index);
      this.editCollectionInfo(guid, 'look');
    },
    // 新增支付计划
    addPaymentPlan(row, event, index) {
      if (!this.dataPermissions(row)) {
        this.$message.warning('创建人才可以操作');
        return;
      }
      let setPageY = index;
      this.$store.commit('setPageY', setPageY);
      this.$store.commit('setCurrentExpand', row);
      let rowData = {
        guid: row.guid,
        payTenantGuid: row.payTenantGuid,
        payTenantName: row.payTenantName,
        receiveTenantGuid: row.receiveTenantGuid,
        receiveTenantName: row.receiveTenantName,
        receiveAmount: row.receiveAmount,
        receiveDate: row.receiveDate,
        correspondItem: row.correspondItem,
        bankName: row.bankName,
        bankAccount: row.bankAccount,
        accountType: row.accountType,
        isCapitalAdvances: row.isCapitalAdvances,
      };
      this.$router.push({
        path: '/addUpstreamPaymentPlan',
        query: {
          guid: row.guid,
          productGuid: this.$route.query.productGuid,
          title: '预支付管理计划',
          rowData: JSON.stringify(rowData),
        },
      });
    },
    getList(callBack) {
      let self = this;
      this.getAmount()
      self.tableLoading = true;
      self.tableData = []
      self.api.postJson(`/${serverConfig.msCustomerService}/invoiceItem/page-list`, self.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records||[];
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
          if (callBack) callBack();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //删除
    delForm(guid) {
      let self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msCustomerService}/invoiceItem/del`, [guid]).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    // 去添加收款信息
    addCollectionInfo() {
      this.showDialogBox = true;
      this.$refs.AddCollectionDialogBox.outerVisible = true;
      this.paramCollection.title = '新增上游收款信息';
      this.paramCollection.operationType = '列表新增方式';
      this.paramCollection.invoiceTenantGuid = ''; // 收票方（支付方）唯一标识
      this.paramCollection.invoiceTenantName = ''; // 收票方（支付方）name
      this.paramCollection.receiveTenantGuid = ''; // 开票方（收款方）唯一标识
      this.paramCollection.receiveTenantName = ''; // 开票方（收款方）唯一标识
      this.paramCollection.correspondItem = ''; // 对应款项
    },
    editCollectionInfo(guid, type) {
      const paramCollectionTitle = type === 'edit' ? '编辑上游收款信息' : '上游收款信息详情';
      let { form } = this;
      this.showDialogBox = true;
      this.$refs.AddCollectionDialogBox.outerVisible = true;
      this.paramCollection.title = paramCollectionTitle;
      this.paramCollection.operationType = '列表编辑方式';
      let self = this;
      self.api.get(`/${serverConfig.msCustomerService}/invoiceItem/detail/${guid}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let { data } = res.data;
          this.$root.$emit('collection-editAndLookData', { data, type });
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    closedDialogBox(val) {
      if (val === 'closed') {
        this.showDialogBox = false;
        this.getList(()=>{
          if (this.$store.getters.getPageY) this.tableScrollToRow(this.$refs.tableRef, this.$store.getters.getPageY); // 表格行跳转
        });
      }
    },
    //获取乙方
    getServiceTenantList() {
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['9904'],
      };
      this.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.serviceTenantList = res.data.data.records;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // todo 展开扩展表
    toogleExpand(row, goBack) {
      let tableRef = this.$refs.tableRef;
      !goBack &&
        this.tableData.forEach((item) => {
          if (row.guid !== item.guid) {
            tableRef.toggleRowExpansion(item, false);
          }
        });
      if (goBack) {
        let currentExpand =
          this.tableData.find((item) => item.guid === this.$store.getters.getCurrentExpand.guid) || {};
        this.$nextTick(() => {
          this.tableData.forEach((item) => {
            if (currentExpand.guid !== item.guid) {
              tableRef.toggleRowExpansion(item, false);
            }
          });
          if (currentExpand.guid) tableRef.toggleRowExpansion(currentExpand);
        });
      } else {
        this.$store.commit('setCurrentExpand', row);
        tableRef.toggleRowExpansion(row);
      }
    },
    /**
     *  el-table滚动到表格某一行
     *  @param {object} tableElement  表格元素(this.$refs['表格ref值'])
     *  @param {Number} rowIndex   滚动到第几行(从0开始)
     */
    tableScrollToRow(tableElement, rowIndex) {
      const theTableRows = tableElement.bodyWrapper.querySelectorAll('.el-table__body tbody .el-table__row');
      let scrollTop = 0;
      for (let i = 0; i < theTableRows.length; i++) {
        if (i === rowIndex) {
          break;
        }
        scrollTop += theTableRows[i].offsetHeight;
      }
      tableElement.bodyWrapper.scrollTop = scrollTop;
    },
  },
};
</script>

<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.button-area{
  display: flex;
  justify-content:space-between;
  align-items: center
}
</style>

<style scoped>
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.management-list {
  display: flex;
  align-items: center;
  /* margin-bottom: 15px; */
}

.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
}

.management-name {
  flex-shrink: 0;
}

.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  border: 1px solid grey;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
}

.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}

.input-item .input-title {
  margin-right: 14px;
}

.add {
  text-align: left;
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}

.del {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 10px;
}

.product-item {
  display: flex;
  margin-top: 10px;
}

.product {
  display: flex;
  align-items: center;
}

.product-img {
  width: 60px;
  height: 60px;
  margin-right: 15px;
}

.product-text {
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reject-btn.btn {
  background: #fff2f4;
  border: 1px solid rgba(255, 219, 224, 1);
  border-radius: 2px;
  color: #fb2323;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.pass-btn.btn {
  background: #f2fff5;
  border: 1px solid rgba(220, 250, 228, 1);
  border-radius: 2px;
  color: #1ba854;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.ing-btn.btn {
  background: #fffbf2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 2px;
  color: #ff991c;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.cancel-btn.btn {
  background: #f5f5f5;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  color: #666;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}
.disable-color {
  color: #999 !important;
  font-weight: 500 !important;
  cursor: pointer;
}
.search-area-div {
  width: 80px;
}
/deep/ .el-col {
  display: flex;
}
</style>
